//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export const TEMPLATE_CONTENT_SCROLL_ID =
  'template-content-slot-scroll-container';

export const TEMPLATE_TOPNAV_HEIGHT = 56;
export const TEMPLATE_FILTERS_WIDTH = 232;
export const TEMPLATE_SIDEBAR_WIDTH = 232;
export const TEMPLATE_HEADER_HEIGHT = 72;

export const DEFAULT_TEMPLATE_STATIC_CONTENT_WIDTH = 960;

export const TEMPLATE_CARD_PADDING = 16;
export const TEMPLATE_GRID_CARD_WIDTH = 224;
export const TEMPLATE_LIST_CARD_WIDTH = 720;
